/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-mutating-methods */
import { ReactElement, useEffect, useState } from 'react'

import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'

import theme from 'src/theme'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchLinkedServices,
  selectLinkedServices,
  selectLinkedServicesStatus,
} from 'src/v3/profile/profile.slice'
import { LearningPathIcon } from 'src/v3/core/icons'
import Subheader from 'src/v3/components/subheader'
import Loading from 'src/v3/components/loading'

export default (): ReactElement => {
  let dispatch = useAppDispatch()

  let linkedServices = useAppSelector(selectLinkedServices)
  let linkedServicesStatus = useAppSelector(selectLinkedServicesStatus)

  let [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    if (linkedServicesStatus === 'uninitialized') {
      dispatch(fetchLinkedServices())
    }
  }, [linkedServicesStatus])

  return (
    <>
      <div className="flex items-center justify-center my-2">
        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
          <LearningPathIcon />
        </Avatar>
        <Typography
          variant="h4"
          className="pl-2"
          style={{
            fontFamily: 'smileAndWave',
          }}
        >
          Linked Services
        </Typography>
      </div>
      <Typography textAlign="center" color="text.secondary" sx={{ mb: 2 }}>
        View linked services associated with your account
      </Typography>
      <Subheader title="Your Linked Services" />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        {linkedServices.map((ls) => (
          <Paper
            key={ls.id}
            variant="outlined"
            sx={{
              p: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flex: '0 0 240px',
              gap: 1,
            }}
          >
            <Avatar
              sx={{
                height: 128,
                width: 128,
                bgcolor: theme.palette.divider,
              }}
            >
              <img
                src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${ls.imageName}`}
                style={{ maxHeight: '100%', maxWidth: '100%', flexGrow: 0 }}
                alt={ls.name}
              />
            </Avatar>
            <Typography textAlign="center" sx={{ p: 0 }}>
              {ls.name}
            </Typography>
          </Paper>
        ))}
      </Box>
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      <Loading entities={[linkedServicesStatus]} />
    </>
  )
}
